import Component from '../inherited/Component'
import axios from 'axios'

export default class TotalValueTooltipTrigger extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._loading = false
  }

  async mount () {
    document.body.addEventListener('click', async e => {
      let matchingElem = e?.target?.closest('[data-total-value-tooltip]')

      if (e.target.matches('[data-total-value-tooltip-content]') || e.target.matches('[data-total-value-tooltip-close]')) {
        let contentElems = document.querySelectorAll('[data-total-value-tooltip-content]')
        for (let elem of contentElems) {
          elem.classList.remove('shown')        
        }
      }

      if (matchingElem) {
        if (this._loading) return
        this._loading = true
        
        let attrValue = matchingElem.getAttribute('data-total-value-tooltip')
        let handle = ''
        let variantId = ''
        if (attrValue.includes('|')) {
          handle = attrValue.split('|')[0]
          variantId = attrValue.split('|')[1]
        } else {
          handle = attrValue
        }

        let contentElem = document.querySelector('[data-total-value-tooltip-content]')

        contentElem.classList.add('content-loading')
        contentElem.classList.add('shown')

        let { data } = await axios.get(`/products/${handle}?view=total-value-ajax&variant=${variantId}`)

        contentElem.querySelector('[data-total-value-tooltip-content-inner]').innerHTML = data

        this._loading = false
        contentElem.classList.remove('content-loading')

      }
    }, true)

  }
}